import * as types from "./types";
import { createReducer } from "../../util/index";

const initialState = {
    loading: false,
    data: [],
};

const spareDomainReducer = createReducer(initialState)({
    [types.SPARE_DOMAIN_LIST]: (state, action) => ({
        ...state,
        spare_domain_list: action.payload
    }),

    [types.SPARE_DOMAIN_CREATE]: (state, action) => ({
        ...state,
        spare_domain_create: action.payload
    }),

    [types.SPARE_DOMAIN_DELETE]: (state, action) => ({
        ...state,
        spare_domain_delete: action.payload
    }),
});

export default spareDomainReducer;